// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_yx4","cls2":"Comments-cls2_WtR Comments-cls1_yx4"};